import  {GET_LIST_TERMS, DELETE_TERM, GET_DETAIL_TERM, CREATE_TERM, UPDATE_TERM} from '@/api/phase2/terms'
export default {
    getListTerm({commit}, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error)
            }
        }
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response)
            }
        }
        GET_LIST_TERMS({payload}, successCallback, errorCallback)
    },
    createTerm({commit}, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error)
            }
        }
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response)
            }
        }
        CREATE_TERM({payload}, successCallback, errorCallback)
    },
    getDetailTerm({commit}, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error)
            }
        }
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response)
            }
        }
        GET_DETAIL_TERM({payload}, successCallback, errorCallback)
    },
    deleteTerm({commit}, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error)
            }
        }
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response)
            }
        }
        DELETE_TERM({payload}, successCallback, errorCallback)
    },
    updateTerm({commit}, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error)
            }
        }
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response)
            }
        }
        UPDATE_TERM({payload}, successCallback, errorCallback)
    },
}
